import { reactive, readonly, computed } from "vue";
import { g as globalShowHideStorageInjectionKey } from "../../../keys-41Cw9q6f.mjs";
const showHidePlugin = {
  install(app) {
    const values = reactive({});
    const fun = ({ id, value, toggle, show, hide }) => {
      values[id] = computed(() => ({ value: value.value, toggle, show, hide }));
      return {
        unregister() {
          delete values[id];
        }
      };
    };
    fun.map = readonly(values);
    app.provide(globalShowHideStorageInjectionKey, fun);
  }
};
export {
  showHidePlugin
};
//# sourceMappingURL=index.mjs.map
